import LanguageRegionCode from '@alltrails/shared/types/LanguageRegionCode';

// eslint-disable-next-line import/prefer-default-export
export function getMonthNamesShort(languageRegionCode: LanguageRegionCode) {
  const { format } = new Intl.DateTimeFormat(languageRegionCode, { month: 'short' });
  return [...Array(12).keys()].map(m => format(new Date(2021, m)));
}
